<template>
  <div class="show-appkey-container">
    <a @click="showAppkeyModal" class='extra-item'>AppKey</a>
    <a-modal
      title="AppKey"
      :visible="visible"
      :footer="null"
      :width="684"
      :maskClosable="false"
      @cancel="handleCancel"
    >
      <a-steps progress-dot :current="current" size="small">
        <a-step title="身份确认" />
        <a-step title="查看" />
      </a-steps>
      <div class="send-msg-container" v-if="current===0">
        <div class="form-container">
          <div class="form-item">
            <label>手机号</label>
            <span>{{phone | desensitize}}</span>
          </div>
          <div class="form-item">
            <label>验证码</label>
            <a-input v-model="verifyCode"></a-input>
            <a-button ghost type="primary" @click="sendMsgCode" v-show="show">短信验证码</a-button>
            <a-button ghost disabled v-show="!show">{{count}}秒后重发</a-button>
          </div>
        </div>
        <div class="action-button">
          <a-button type="primary" @click="handleNext" :loading="loading">下一步</a-button>
        </div>
      </div>
      <div class="appkey-container" v-if="current===1">
        <div class="content">
          <span>{{appkey}}</span>
          <a-popconfirm
            ok-text="确定"
            cancel-text="取消"
            @confirm="confirm"
          >
            <template slot="title">
              <h3>确定要更新AppKey吗？</h3>
              <p class="info">请注意：更新AppKey立即生效，所有使用旧AppKey的接口将立即失效。为确保正常使用，请尽快更新AppKey信息。</p>
            </template>
            <a>更新</a>
          </a-popconfirm>
        </div>
        <div class="action-button">
          <a-button type="primary" @click="handleCancel">知道了</a-button>
        </div>
      </div>
    </a-modal>
  </div>
</template>
<script>
  import { mapActions } from 'vuex'
  import { Modal, Button, Steps, Input, Popconfirm } from 'ant-design-vue'
  import Cookies from 'js-cookie'
  import { REG_PHONE } from '@/utils/constants'
  export default {
    name: 'show-appkey',
    components: {
      [Modal.name]: Modal,
      [Button.name]: Button,
      [Steps.name]: Steps,
      [Steps.Step.name]: Steps.Step,
      [Input.name]: Input,
      [Popconfirm.name]: Popconfirm
    },
    data() {
      return {
        visible: false,
        current: 0,
        phone: Cookies.get('siteMobile'),
        show: true,
        count: 0,
        timer: null,
        verifyCode: '',
        loading: false,
        appkey: ''
      }
    },
    methods: {
      ...mapActions('popHome',[
        'sendPhoneMsg',
        'getAppKey',
        'updateAppkey'
      ]),
      showAppkeyModal() {
        this.current = 0
        this.verifyCode = ''
        this.loading = false
        this.appkey = ''
        this.visible = true
      },
      handleCancel() {
        this.visible = false
        this.timerReset()
      },
      timerStart() {
        const TIME_COUNT = 60
        if (!this.timer) {
          this.count = TIME_COUNT
          this.show = false
          this.timer = setInterval(() => {
            if (this.count > 1 && this.count <= TIME_COUNT) {
              this.count--
            } else {
              this.timerReset()
            }
          }, 1000)
        }
      },
      timerReset() {
        this.timer !== null && clearInterval(this.timer)
        this.show = true
        this.timer = null
        this.count = 0
      },
      async sendMsgCode() {
        if(!REG_PHONE.test(this.phone)) {
          this.$message.error('手机号非法，请修改手机号')
          return
        }
        this.timerStart()
        const param = {
          serviceCode: 'AppKey'
        }
        const res = await this.sendPhoneMsg({param: JSON.stringify(param)})
        if(res && res.code === '1'){
          this.$message.success('验证码已发送至手机，5分钟内输入有效，请勿泄漏！')
        } else if(res) {
          this.$message.error(res.msg || '验证码发送失败，请稍后重试！')
        } else {
          this.$message.error('验证码发送失败，请稍后重试！')
        }
      },
      async handleNext() {
        if(!REG_PHONE.test(this.phone)) {
          this.$message.error('手机号非法，请修改手机号')
          return
        }
        if(this.verifyCode === '' || this.verifyCode === null || this.verifyCode === undefined){
          this.$message.error('验证码不能为空')
          return
        }
        // 调用接口获取appkey
        const params = {
          loginName: Cookies.get('siteLoginName'),
          appServiceCode: 'AppKey',
          identity: this.phone,
          verifyCode: this.verifyCode
        }
        this.loading = true
        const res = await this.getAppKey(params)
        this.loading = false
        if(res && res.code === '1' && res.data && res.data.appkey) {
          this.appkey = res.data.appkey
          this.current = 1
        }else if(res){
          this.$message.error(res.msg || '获取AppKey失败！')
        }else{
          this.$message.error('获取AppKey失败！')
        }
        this.timerReset()
      },
      async confirm() {
        const res = await this.updateAppkey({
          loginName: Cookies.get('siteLoginName'),
          appkey: this.appkey
        })
        if(res && res.code === '1' && res.data && res.data.appkey) {
          this.appkey = res.data.appkey
          this.$message.success('更新AppKey成功')
        }else if(res){
          this.$message.error(res.msg || '更新AppKey失败！')
        }else{
          this.$message.error('更新AppKey失败！')
        }
      },
    },
    filters: {
      desensitize(value) {
        if(!value) return ''
        value = value.toString()
        if(value.length !== 11){
          return ''
        }
        return value.substring(0, 3) + '****' + value.substring(7)
      }
    }
  }
</script>
<style lang="scss" scoped>
  .show-appkey-container {
    display: inline-block;
  }
  .send-msg-container, .appkey-container {
    min-height: 160px;
    padding: 30px 50px 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .appkey-container {
    .action-button {
      margin-top: 68px;
    }
  }
  .form-container {
    .form-item {
      display: flex;
      align-items: center;
      & > label {
        flex-grow: 0;
        flex-shrink: 0;
        color: #666666;
        margin-right: 20px;
      }
      & > span {
        color: #333333;
      }
      & > input {
        margin-right: 20px;
        width: 200px;
        color: #333333;
      }
      & > button {
        width: 102px;
      }
      &:not(:last-child){
        margin-bottom: 10px;
      }
    }
  }
  .content {
    display: flex;
    justify-content: center;
    align-items: center;
    & > span {
      margin-right: 20px;
    }
  }
  .action-button {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 30px;
  }
  .info {
    width: 300px;
    margin-top: 10px;
  }
</style>